<template>
  <div class="picker-color">
    <p>{{ label }}</p>
    <div>
      <el-button type="text" size="mini" @click="reset">重置</el-button>
      <el-color-picker
        v-if="!isGradient"
        :value="value"
        @change="val => $emit('input', val)"
        show-alpha
      ></el-color-picker>
      <SpPickerGradientColor
        v-else
        :value="value"
        @input="val => $emit('input', val)"
      />
    </div>
  </div>
</template>

<script>
import SpPickerGradientColor from "./SpPickerGradientColor";
export default {
  props: {
    isGradient: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      require: true
    },
    defaultColor: {
      type: String,
      default: "rgba(255,255,255,0)"
    }
  },
  components: {
    SpPickerGradientColor
  },
  methods: {
    reset() {
      this.$emit("input", this.defaultColor);
    }
  }
};
</script>

<style lang="less" scoped>
.picker-color {
  display: flex;
  align-items: center;
  justify-content: space-between;
  > p {
    min-width: 72px;
    font-size: 12px;
    color: #999999;
    font-weight: 400;
  }
  > div {
    display: flex;
    align-items: center;
    /deep/ .el-button {
      color: #2154f4;
      font-size: 12px;
      margin-right: 10px;
    }
    /deep/ .el-color-picker {
      .el-color-picker__trigger {
        width: 70px;
        height: 32px;
      }
      .el-color-picker__icon {
        display: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/components/SpPickerColor.vue